<template>
  <div>
    <v-row align="center">
      <v-icon>mdi-clock-outline</v-icon>
      <div>{{ $t("story.duration") }}</div>
    </v-row>
    <v-row>
        <v-text-field
          v-model="duration"
          style="max-width: 4em"
          class="mr-4"
          placeholder="mm:ss"
          v-mask="'##:##'"
          outlined
          solo
        />
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    value: String,
    disabled: Boolean,
  },
  data() {
    return {
      duration: this.value
    }
  },
  watch: {
    value(newValue) {
      if (this.duration != newValue) {
        this.duration = newValue
      }
    },
    duration(newValue) {
      this.$emit('input', newValue)
    },
  },
}
</script>